/**
 * Mention Review Helper Functions
 *
 * Shared utility functions for mention review components
 * Sprint 014 SESSION_118: Re-export working utilities from dateUtils instead of duplicating buggy code
 */

import { parseAsUTC } from '@/infrastructure/utils/dateUtils';

/**
 * Formats a date string to user's local timezone with correct UTC interpretation
 * Sprint 014 SESSION_118: Fixed timezone bug - backend sends UTC without 'Z' suffix
 * @param dateString ISO 8601 date string (from backend UTC time)
 * @returns Formatted date with timezone
 */
export const formatRedditDate = (dateString: string): string => {
  try {
    const date = parseAsUTC(dateString);  // ✅ Forces UTC interpretation

    // Use browser's timezone automatically
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZoneName: 'short'
    }).format(date);
  } catch (error) {
    console.error('Date formatting error:', error);
    return 'Invalid date';
  }
};
